/**
 * Format milliseconds to a human-readable time duration
 * @param ms Milliseconds to format
 * @param t Translation function
 * @returns Formatted time string (e.g., "5.2 days", "3.4 hours")
 */
export function formatDuration(
  ms: number,
  t: (key: string, count?: number) => string,
): string {
  const seconds = (ms / 1000).toFixed(1);
  const minutes = (ms / (1000 * 60)).toFixed(1);
  const hours = (ms / (1000 * 60 * 60)).toFixed(1);
  const days = (ms / (1000 * 60 * 60 * 24)).toFixed(1);

  if (Number(seconds) < 60) {
    return `${seconds} ${t("global.time.seconds", Number(seconds))}`;
  } else if (Number(minutes) < 60) {
    return `${minutes} ${t("global.time.minutes", Number(minutes))}`;
  } else if (Number(hours) < 24) {
    return `${hours} ${t("global.time.hours", Number(hours))}`;
  } else {
    return `${days} ${t("global.time.days", Number(days))}`;
  }
}
